// Import games data to check which games require subscription
import { getGameById } from './gamesService';

// Global flag to control access to all games
export let accessAllowed = false;

// Mock user data - in a real app, this would come from your backend/database
const mockUser = {
  id: 1,
  subscription: {
    plan: 'premium', // 'free', 'premium', 'expired'
    expiryDate: new Date('2024-12-31')
  }
};

/**
 * Check if user has subscription access to a specific game
 * @param {string} gameId - The ID of the game to check
 * @param {object} user - User object (optional, uses mock data if not provided)
 * @returns {boolean} - True if user has access, false otherwise
 */
export const checkGameSubscription = (gameId, user = mockUser) => {
  // First check the global access flag
  if (accessAllowed) {
    return true;
  }
  
  // If global access is not allowed, check game-specific access
  const game = getGameById(gameId);
  
  // If game doesn't exist, deny access
  if (!game) {
    return false;
  }
  
  // If game doesn't require subscription, allow access
  if (!game.requiresSubscription) {
    return true;
  }
  
  // If game requires subscription, check if user has premium subscription
  if (!user.subscription) {
    return false;
  }
  
  // Check if subscription is expired
  const currentDate = new Date();
  if (user.subscription.expiryDate < currentDate) {
    return false;
  }
  
  // Check if user has premium plan
  return user.subscription.plan === 'premium';
};

/**
 * Get user's subscription status
 * @param {object} user - User object (optional, uses mock data if not provided)
 * @returns {object} - Subscription status object
 */
export const getSubscriptionStatus = (user = mockUser) => {
  if (!user.subscription) {
    return { hasSubscription: true, plan: 'none', isExpired: false };
  }
  
  const currentDate = new Date();
  const isExpired = user.subscription.expiryDate < currentDate;
  
  return {
    hasSubscription: !isExpired,
    plan: user.subscription.plan,
    isExpired,
    expiryDate: user.subscription.expiryDate
  };
};

/**
 * Toggle the global access flag
 * @param {boolean} value - New value for the access flag
 */
export const setAccessAllowed = (value) => {
  accessAllowed = value;
};
